'use client';
import Typography from '@/components/core/Typography/Typography';
import { ForwardedRef, forwardRef, useCallback } from 'react';
import { useForwardRef } from '@/utils/useForwardRef';
import { buttonVariants } from '@/components/core/Button/styles';

const Button = forwardRef(function DirectButton({
    variant = 'filled',
    innerText,
    startAdornment,
    endAdornment,
    leftIcon,
    rightIcon,
    size = 'sm',
    error = false,
    disabled = false,
    onClick,
    withBlur = true,
    icon,
    highlighted = false,
    ...props
}: Record<string, any>, forwardedRef: ForwardedRef<HTMLButtonElement>) {
    const ref = useForwardRef(forwardedRef);

    const handleClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        if (ref && withBlur) {
            ref.current.blur();
        }

        if (onClick) {
            onClick(e);
        }
    }, [onClick, ref, withBlur]);

    const Component = buttonVariants[variant];

    return (
        <Component
          ref={ref}
          onClick={onClick && withBlur ? handleClick : undefined}
          size={size}
          data-error={error ? true : undefined}
          disabled={disabled ? true : undefined}
          type={props.type || 'button'}
          $icon={icon}
          $highlighted={highlighted}
          {...props}
        >
            {startAdornment || leftIcon}
            {innerText && (
                typeof innerText === 'string'
                    ? <Typography variant='uiType' modifier='S' size={size === 'xs' ? 'xs' : 'sm'}>{innerText}</Typography>
                    : innerText
            )}
            {endAdornment || rightIcon}
        </Component>
    );
});

export default Button;
